<template>
	<div class="banner" :class="{ '--margin-bottom': marginBottom }">
		<BContainer>
			<svg
				v-if="brand === 'sculptnation'"
				xmlns="http://www.w3.org/2000/svg"
				width="130"
				height="22"
				viewBox="0 0 130 22"
				fill="none"
				aria-label="SculptNation logo"
			>
				<g clip-path="url(#clip0_160_17496)">
					<path
						d="M9.1 13.9V17.3C9.1 19.9 7.8 21.2 5.2 21.2H3.8C1.2 21.2 0 19.9 0 17.4V13H3.1V17.3C3.1 18.1 3.5 18.5 4.3 18.5H4.7C5.6 18.4 6 18 6 17.2V14.3C6 13.4 5.7 13.1 5.1 12.6L1.9 10.2C0.4 9.3 0 8.3 0 6.7V3.9C0 1.3 1.3 0 3.9 0H5.2C7.8 0 9 1.3 9 3.8V7.6H5.9V3.9C5.9 3.1 5.5 2.7 4.7 2.7H4.3C3.5 2.8 3.2 3.2 3.2 4V6.3C3.2 7.1 3.5 7.6 4 8L7.2 10.4C8.7 11.3 9.1 12.2 9.1 13.9Z"
						fill="white"
					/>
					<path
						d="M20.1 12.5V17.4C20.1 20 18.8 21.3 16.2 21.3H14.6C12 21.3 10.7 20 10.7 17.4V3.9C10.7 1.3 12 0 14.6 0H16.1C18.8 0 20 1.3 20 3.8V8.1H16.9V4C16.9 3.2 16.5 2.8 15.7 2.8H15.2C14.3 2.8 14 3.2 14 4V17.2C14 18 14.4 18.4 15.2 18.4H15.8C16.6 18.4 17 18 17 17.2V12.5H20.1Z"
						fill="white"
					/>
					<path
						d="M31.1 17.3002C31.1 19.9002 29.8001 21.2002 27.2001 21.2002H25.7001C23.1001 21.2002 21.8 19.9002 21.8 17.3002V0.200195H25V17.2002C25 18.0002 25.4001 18.4002 26.2001 18.4002H26.7001C27.5001 18.4002 27.9 18.0002 27.9 17.2002V0.200195H31.1V17.3002Z"
						fill="white"
					/>
					<path
						d="M36.2 0.200195V18.2002H39.7V21.0002H33V0.200195H36.2Z"
						fill="white"
					/>
					<path
						d="M44.4 21.0002H41.2V0.200195H46.2C48.8 0.200195 50 1.5002 50 4.0002V9.5002C50 12.1002 48.6999 13.4002 46.0999 13.4002H44.2999V21.0002H44.4ZM45.7 3.0002H44.4V10.7002H45.7C46.5 10.7002 46.9 10.3002 46.9 9.5002V4.2002C46.9 3.4002 46.5 3.0002 45.7 3.0002Z"
						fill="white"
					/>
					<path
						d="M53.5999 21.0002V3.0002H50.7V0.200195H59.5999V3.1002H56.7V21.1002H53.5999V21.0002Z"
						fill="white"
					/>
					<path
						d="M59.8 4.7H62.8V5.8C63.6 5.1 64.4 4.5 65.7 4.5H65.8001C67.5001 4.5 68.4001 5.5 68.4001 7.3V21H65.4001V8.2C65.4001 7.5 65.1001 7.2 64.4001 7.2C63.8001 7.2 63.4 7.4 62.8 7.7V21H59.8V4.7Z"
						fill="white"
					/>
					<path
						d="M70 15.1C70 13.2 70.6 12.4 72.3 11.8L75.4 10.7V8.2C75.4 7.5 75 7.1 74.3 7.1H74.1C73.4 7.1 73 7.5 73 8.2V10.2H70.2V8.1C70.2 5.7 71.4 4.5 73.8 4.5H74.8C77.2 4.5 78.4 5.7 78.4 8.1V21H75.4V20C74.7 20.7 73.9 21.2 72.6 21.2C70.9 21.2 70 20.2 70 18.4V15.1ZM75.4 18V13.3L73.8 13.9C73.1 14.2 72.9 14.5 72.9 15.2V17.5C72.9 18.1 73.2 18.4 73.9 18.4C74.4 18.5 74.9 18.3 75.4 18Z"
						fill="white"
					/>
					<path
						d="M83.6 21H80.6V7.3H79.5V4.7H80.6V2H83.6V4.7H85.2V7.3H83.6V21Z"
						fill="white"
					/>
					<path
						d="M86.3 0.399902H89.4V3.2999H86.3V0.399902ZM86.4 4.6999H89.4V20.9999H86.4V4.6999Z"
						fill="white"
					/>
					<path
						d="M94.8 21.2C92.4 21.2 91.2 20 91.2 17.6V8.1C91.2 5.7 92.4 4.5 94.8 4.5H96.2C98.6 4.5 99.8 5.7 99.8 8.1V17.5C99.8 19.9 98.6 21.1 96.2 21.1H94.8V21.2ZM95.2 7.2C94.5 7.2 94.1 7.6 94.1 8.3V17.4C94.1 18.1 94.5 18.5 95.2 18.5H95.7C96.4 18.5 96.8 18.1 96.8 17.4V8.3C96.8 7.6 96.4 7.2 95.7 7.2H95.2Z"
						fill="white"
					/>
					<path
						d="M101.5 4.7H104.5V5.8C105.3 5.1 106.1 4.5 107.4 4.5H107.5C109.2 4.5 110.1 5.5 110.1 7.3V21H107.1V8.2C107.1 7.5 106.8 7.2 106.1 7.2C105.5 7.2 105.1 7.4 104.5 7.7V21H101.5V4.7Z"
						fill="white"
					/>
					<path
						d="M113.1 9.79957C113.1 8.59957 113.8 8.29957 114.6 9.19957L119.1 13.7996C119.9 14.5996 119.9 15.9996 119.1 16.8996L114.6 21.4996C113.8 22.2996 113.1 22.0996 113.1 20.8996V9.79957Z"
						fill="#ED1C24"
					/>
					<path
						d="M117.1 20.3998C116.3 21.1998 116.6 21.8998 117.7 21.8998H121.5C122.7 21.8998 124.3 21.1998 125.2 20.3998L129.1 16.4998C129.9 15.6998 129.9 14.2998 129.1 13.3998L121.5 5.7998C120.7 4.9998 119 4.2998 117.8 4.2998H113.7C112.5 4.2998 112.2 4.9998 113.1 5.7998L120.8 13.4998C121.6 14.2998 121.6 15.6998 120.8 16.5998L117.1 20.3998Z"
						fill="#ED1C24"
					/>
				</g>
				<defs>
					<clipPath id="clip0_160_17496">
						<rect width="129.7" height="22" fill="white" />
					</clipPath>
				</defs>
			</svg>

			<svg
				v-if="brand === 'vshred'"
				width="93"
				height="22"
				viewBox="0 0 93 22"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
				aria-label="VShred logo"
			>
				<path
					d="M28.2722 10.1175C28.7135 10.9685 28.7765 11.788 28.3668 12.639L27.2951 15.0029C26.6963 16.3582 25.6877 17.0201 24.3009 17.0201H13.9943L15.8223 13.0172L17.4298 9.48711L20.2034 11.5673L19.5415 13.0172H22.8825C22.9771 12.8281 22.914 12.5759 22.7249 12.2292L19.8567 6.9341C19.4155 6.08309 19.3524 5.26361 19.7622 4.41261L20.8338 2.04871C21.4327 0.724928 22.4413 0.0315186 23.8281 0.0315186H34.1662L32.3381 4.03438L30.7307 7.56447L27.9255 5.48424L28.5874 4.03438H25.2464C25.1519 4.2235 25.2149 4.47564 25.404 4.82235L28.2722 10.1175ZM41.2264 6.49284L44.1891 0H49.4842L41.6991 16.9885H36.4355L39.3983 10.4957H36.4355L33.4728 16.9885H28.1777L35.9627 0H41.2579L38.2951 6.49284H41.2264ZM54.7478 4.03438L53.0774 7.69054H55.1576C55.7564 7.69054 56.1977 7.37536 56.4814 6.74499L57.3009 4.97994C57.5845 4.34957 57.4269 4.03438 56.8596 4.03438H54.7478ZM51.6905 11.6934H51.2493L48.8223 16.9885H43.5272L51.3123 0H62.8166C64.2034 0 64.5817 0.661891 63.9513 2.01719L60.4527 9.67622C59.8539 11 58.8453 11.6934 57.4585 11.6934H57.1117L57.8682 16.9885H52.4785L51.6905 11.6934ZM67.1031 10.5272L65.9685 13.0172H73.0602L71.2321 17.0201H58.8453L66.6304 0.0315186H78.9857L77.1576 4.03438H70.0659L68.9312 6.52436H74.8252L72.9971 10.5272H67.1031ZM84.2493 4.03438L80.1519 12.9857H81.7593C82.3582 12.9857 83.2722 12.639 83.9656 11.1576L86.3925 5.86246C87.0544 4.41261 86.4556 4.00287 85.8882 4.00287L84.2493 4.03438ZM72.9971 17.0201L80.7822 0.0315186H90.3009C91.6877 0.0315186 93.9255 1.0086 92.4126 4.25501L88.4097 12.9857C87.3696 15.2235 83.8711 17.0201 82.5158 17.0201H72.9971ZM0 0H7.06017L8.57307 4.03438H7.09169L10.0229 10.4957L12.9542 4.03438H11.4728L12.9542 0H20.0458L10.0229 22L0 0Z"
					fill="white"
				/>
			</svg>
		</BContainer>
	</div>
</template>

<script>
export default {
	props: {
		marginBottom: {
			type: Boolean,
			default: true,
		},
		brand: {
			type: String,
			default: 'sculptnation',
		},
	},
};
</script>

<style lang="scss" scoped>
.banner {
	height: var(--size-xxl);
	background: var(--gray-800);
	display: flex;
	align-items: center;

	@media screen and (min-width: 992px) {
		margin-bottom: var(--size-lg);
	}

	&.--margin-bottom {
		margin-bottom: var(--size-md);
	}
}
</style>
